const showFullDescription = () => {
  const button = document.querySelector("#description-button");

  button.addEventListener("click", ()=> {
    const description = document.querySelector(".product-wrapper_content.full-description");

    description.classList.toggle("hidde");
  })
}

const descriptionTabs = () => {
  const parents = document.querySelectorAll(".description-tabs");

  parents.forEach(parent => {
    const tabsTitles = parent.querySelectorAll(".tabs-title");
    const tabContents = parent.querySelectorAll(".tabs-content");
    
    if (tabsTitles.length > 0) {
      tabsTitles.forEach(tabTitle => {
        tabTitle.addEventListener("click", () => {
  
          tabsTitles.forEach(element => {
            element.classList.remove("active");
          });
          
          tabTitle.classList.add("active");
  
          const tabIndex = tabTitle.dataset.index;
  
          tabContents.forEach(tab => {
            tab.classList.remove("active");
          });
  
          tabContents[tabIndex-1].classList.add("active");
        })
      });
    }
  });

}

showFullDescription();
descriptionTabs();
